import React from "react";
import { AttentionItemCard } from "./AttentionItemCard";
import type { AttentionItemCardProps } from "./AttentionItemCard";
import { useNeedsYourAttention } from "../../hooks/useNeedsYourAttention";
import { AttentionSectionSkeleton } from "../shared/AttentionSectionSkeleton";

export interface NeedsYourAttentionSectionProps {
  items?: AttentionItemCardProps[];
}

export function NeedsYourAttentionSection() {
  const { items: hookItems, loading, error } = useNeedsYourAttention();
  const items = hookItems;

  return (
    <>
      <div className="flex items-center gap-3">
        <div className="flex h-4 w-1 flex-none flex-col items-start rounded-full bg-error-600" />
        <span className="text-caption-bold font-caption-bold text-neutral-600 uppercase tracking-widest">
          NEEDS YOUR ATTENTION
        </span>
      </div>
      {loading ? (
        <AttentionSectionSkeleton />
      ) : error ? (
        <p className="text-body text-error-600">{error}</p>
      ) : (
        <div className="flex w-full flex-col items-start gap-3">
          {items.map((item, i) => (
            <AttentionItemCard key={i} {...item} />
          ))}
        </div>
      )}
    </>
  );
}
